export const VIDEO_ID = "04bFyWr3vGc";
export const VIDEO_URL = `https://youtu.be/${VIDEO_ID}`;
export const EMBED_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`;
export const THUMB_URL = `https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`;
export const THUMB_FALLBACK = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`;

export const EMAIL = "golden.hp85@gmail.com";
export const PHONE_DISPLAY = "(720) 645-6999";
export const PHONE_TEL = "+17206456999";

export const IMAGES = {
  stageWarm: "/photos/stage-warm.jpg",
  lounge: "/photos/lounge-vocals.jpg",
  guitar: "/photos/acoustic-guitar.png",
  timesSquare: "/photos/times-square.jpg",
  studioHeadphones: "/photos/studio-headphones.jpg",
};
